import { render, staticRenderFns } from "./MoreSailDatePopup.vue?vue&type=template&id=b2202588"
import script from "./MoreSailDatePopup.vue?vue&type=script&lang=js"
export * from "./MoreSailDatePopup.vue?vue&type=script&lang=js"
import style0 from "./MoreSailDatePopup.vue?vue&type=style&index=0&id=b2202588&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports